/**
 * OverlayPortal: the layer every full-screen overlay draws in (Dialog,
 * BottomSheet, Drawer and the few hand-built overlays).
 *
 * An overlay drawn where its opener sits is held in that place's stacking
 * context: a sticky or fixed ancestor (the Directory page's contact aside
 * is lg:sticky), a transform, a filter or a z-index on a positioned
 * ancestor caps it, however high its own z-index, so the sticky top bar
 * (AppShell's header, z-50) painted over the dialog's heading. Drawn as a
 * child of document.body, the overlay's z-index is compared with the top
 * bar's directly, on every page.
 *
 * Every overlay takes the same layer: a wrapper at OVERLAY_LAYER_Z
 * (above the top bar's z-50) that holds the overlay's own z-indexes
 * inside it. Overlays then stack in the order they open, so a dialog
 * opened from a bottom sheet sits over the sheet whatever their own
 * z-indexes are.
 *
 * React events still bubble through the React tree, so an opener's
 * handlers behave as before. tests/ui/OverlayAboveTopBar.test.tsx pins
 * each overlay's placement and that its layer sits above the top bar.
 */
import type { ReactNode } from 'react';
import { createPortal } from 'react-dom';

/** The overlay layer's z-index (the wrapper's class is z-[100]). */
export const OVERLAY_LAYER_Z = 100;

export function OverlayPortal({ children }: { children: ReactNode }): ReactNode {
  return createPortal(
    <div className="relative z-[100]" data-overlay-layer="">
      {children}
    </div>,
    document.body,
  );
}
